import React, { useMemo, useState } from 'react';
import CommonBubble from '@home/components/CommonBubble';
import info from '@sg/assests/svg/info.svg';
import infoHover from '@sg/assests/svg/info-hover.svg';
import DOMPurify from 'dompurify';
import './index.scss';

interface IconType {
  tipString?: React.ReactNode;
  className?: string;
  mWidth?: string;
  style?: React.CSSProperties;
  overlayClassName?: string;
  overlayMaxHeight?: string;
  useAutoBubbleWidth?: boolean;
}

export default function SvgIcon(props: IconType) {
  const {
    tipString,
    className,
    mWidth,
    style,
    overlayClassName,
    overlayMaxHeight,
    useAutoBubbleWidth = true,
  } = props;
  const [isIconHover, setIsIconHover] = useState(false);

  const sanitizedContent = useMemo(() => {
    if (typeof tipString !== 'string') {
      return tipString;
    }

    const newText = tipString.replace(/(\\n|\n)/g, '<br/>');
    return DOMPurify.sanitize(newText);
  }, [tipString]);

  const bubbleContent = useMemo(() => {
    if (mWidth) {
      if (typeof tipString === 'string') {
        return (
          <div
            className="db-tipcontext-content"
            style={{
              maxHeight: overlayMaxHeight || 'unset',
              whiteSpace: 'normal',
              wordBreak: 'break-word',
              overflowWrap: 'anywhere',
            }}
            dangerouslySetInnerHTML={{ __html: sanitizedContent as string }}
          />
        );
      }

      return (
        <div style={{ whiteSpace: 'normal', wordBreak: 'break-word', overflowWrap: 'anywhere' }}>
          {tipString}
        </div>
      );
    }

    return typeof tipString === 'string'
      ? <div style={{ whiteSpace: 'nowrap' }}>{tipString}</div>
      : tipString;
  }, [mWidth, overlayMaxHeight, sanitizedContent, tipString]);

  const handleMouseEnter = () => {
    setIsIconHover(true);
  };

  const handleMouseLeave = () => {
    setIsIconHover(false);
  };

  return (
    <div className={`dbs-icon-tips-icon ${className || ''}`}>
      <CommonBubble
        placement="top"
        dark
        overlayClassName={overlayClassName}
        style={useAutoBubbleWidth ? { maxWidth: mWidth || 'none', width: 'auto' } : undefined}
        content={bubbleContent}
      >
        <div
          className="dbs-icon-tips-wrapper"
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
          style={{
            width: '16px',
            height: '16px',
            ...style,
          }}
        >
          <img
            src={isIconHover ? infoHover : info}
            alt="info"
            className="dbs-icon-tips-icon-svg"
            style={{
              width: '16px',
              height: '16px',
            }}
          />
        </div>
      </CommonBubble>
    </div>
  );
}
